import { useEffect } from 'react';
export var useBackdropFilter = function useBackdropFilter(elementRef) {
  useEffect(function () {
    elementRef.current.style.setProperty('backdrop-filter', 'blur(30px)');
    elementRef.current.style.setProperty('-webkit-backdrop-filter', 'blur(30px)');
  }, [elementRef]);
};